const legacyDownloadMessage = 'This file is not a MongoDB Extended JSON provision download. Refresh Production Console, download the provision JSON again, and select the new file.';
const binaryFields = ['productV', 'configV', 'fwV', 'protoV', 'appVersion', 'otaVersion', 'bootLoaderVersion'];
const bsonTags = ['$date', '$binary', '$oid', '$numberInt', '$numberLong', '$numberDouble',
  '$numberDecimal', '$timestamp', '$regularExpression', '$minKey', '$maxKey', '$code',
  '$symbol', '$dbPointer', '$uuid', '$undefined'];
const owns = (value, key) => Object.prototype.hasOwnProperty.call(value, key);

function hasBsonTag(value) {
  if (!value || typeof value !== 'object') return false;
  return Object.keys(value).some(key => bsonTags.includes(key) || hasBsonTag(value[key]));
}

function getProvisionFormatError(data) {
  // The previous exporter always flattened these binary fields to hex strings.
  // A BSON tag elsewhere must not make that lossy file eligible for insertion.
  const hasFlattenedBinary = binaryFields.some(key => owns(data, key) && data[key] != null &&
    (typeof data[key] !== 'object' || !owns(data[key], '$binary')));
  return hasFlattenedBinary || !hasBsonTag(data) ? legacyDownloadMessage : null;
}

module.exports = { getProvisionFormatError };
